import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchUser = (userId) => apiActionCreator({
  'endpoint': `/users/${userId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_USER,
    ActionTypes.FETCHED_USER,
    [
      ActionTypes.FETCHED_USER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getUsers = () => apiActionCreator({
  'endpoint': '/users',
  'authenticated': true,
  'types': [
    ActionTypes.GET_USERS_REQUEST,
    ActionTypes.GET_USERS_SUCCESS,
    [
      ActionTypes.GET_USERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
